"use strict"

import React from "react"

import TIME_EXTRACTORS from "../graphing/resources/TimeExtractors"
import { isLTPM } from "../../components/shared_components_registration"

const ConfigContext = React.createContext({})

export function withPlotSettingsConfig(Component) {
  return function (props) {
    return (
      <ConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </ConfigContext.Consumer>
    )
  }
}

export default class PlotSettingsConfigProvider extends React.Component {
  static defaultProps = {
    timeExtractors: TIME_EXTRACTORS,
  }
  constructor(props) {
    super(props)

    this.state = {
      settings: {
        timeExtractor: !props.timestampDefault ? props.timeExtractors[0] : props.timeExtractors[1],
        alignment: !props.timestampDefault ? props.timeExtractors[0] : props.timeExtractors[1],
        downsampleObservations: true,
        reloadInterval: isLTPM ? 3600e3 : 7200e3, // 60/120 minutes - If applicable, runs on UI will reload every passing reloadInterval
      },
    }

    this.updateSettings = this.updateSettings.bind(this)
    this.setDayTimeExtractor = this.setDayTimeExtractor.bind(this)
    this.setTSTimeExtractor = this.setTSTimeExtractor.bind(this)
  }

  render() {
    return (
      <ConfigContext.Provider
        value={{
          ...this.state.settings,

          updateSettings: this.updateSettings,
          setDayTimeExtractor: this.setDayTimeExtractor,
          setTSTimeExtractor: this.setTSTimeExtractor,
        }}
      >
        {this.props.children}
      </ConfigContext.Provider>
    )
  }

  updateSettings(update) {
    this.setState((state) => {
      return {
        settings: {
          ...state.settings,
          ...update,
        },
      }
    })
  }

  setDayTimeExtractor() {
    this.updateSettings({
      timeExtractor: this.props.timeExtractors[0],
      alignment: this.props.timeExtractors[0],
    })
  }

  setTSTimeExtractor() {
    this.updateSettings({
      timeExtractor: this.props.timeExtractors[1],
      alignment: this.props.timeExtractors[1],
    })
  }
}
